import React, { useEffect, useState, useRef } from "react";
import { Timeline } from "primereact/timeline";
import axios from "axios";
import "primereact/resources/themes/saga-blue/theme.css"; // or any other theme you prefer
import "primereact/resources/primereact.min.css";
import "primeicons/primeicons.css";
import "../../../App.css"; // Ensure you import your custom CSS
import LeadDbService from "../../Services/LeadDbService";
import AudioPlayer from "./AudioPlayer";
import { Music } from "lucide-react";

const LeadNotesHistory = ({ docId }) => {
  console.log(`lead${docId}`);
  const [events, setEvents] = useState([]);
  const audioPlayersRef = useRef(new Map());

  // useEffect(() => {
  //   const fetchLeadHistory = async () => {
  //     try {
  //       const response = await axios.get(
  //         `https://value-realitty-backend-665385455484.asia-south1.run.app/api/v1/getLeadHistoryByDocId?docId=${docId}`
  //       );
  //       const history = response.data.history.map((item) => ({
  //         log: item.log,
  //         timestamp: new Date(item.timestamp).toLocaleString(),
  //       }));
  //       setEvents(history);
  //     } catch (error) {
  //       console.error("Error fetching lead history:", error);
  //     }
  //   };

  //   fetchLeadHistory();
  // }, [docId]);

  useEffect(() => {
    const fetchLeadNotesHistory = async () => {
      try {
        const response = await LeadDbService.fetchLeadNotesHistoryByDocId(
          docId
        );
        const history = response.data.history.map((item) => ({
          log: item.log || null,
          timestamp: item.timestamp,
          updatedBy : item.addedBy || null,
          audioUrl : item.audioUrl || null,
        }));
        setEvents(history);
      } catch (error) {
        console.error("Error fetching lead history:", error);
      }
    };

    fetchLeadNotesHistory();
  }, [docId]);

  // Function to handle audio play and pause other audios
  const handleAudioPlay = (audioId) => {
    // Pause all other audio players
    audioPlayersRef.current.forEach((pauseFunction, id) => {
      if (id !== audioId) {
        pauseFunction();
      }
    });
  };

  // Function to register audio player
  const registerAudioPlayer = (audioId, pauseFunction) => {
    audioPlayersRef.current.set(audioId, pauseFunction);
  };

  // Function to unregister audio player
  const unregisterAudioPlayer = (audioId) => {
    audioPlayersRef.current.delete(audioId);
  };
  return (
    <div className="bg-white shadow-md rounded w-full p-4 h-96 ">
      <div className="bg-slate-100 p-2 mb-4 rounded-[10px] ">
        <div className="text-customGreen text-xl font-semibold">
          Lead Notes History
        </div>
      </div>

      {events.length > 0 ? (
        <div className="w-full h-[300px] overflow-y-auto custom-scrollbar ">
          <Timeline
            className="px-10 xl:px-1 mt-6"
            value={events}
            opposite={(item) => (
              <small className="text-color-secondary text-[13px] font-semibold xl:text-[13px] w-full">
                {item.timestamp}
              </small>
            )}
            content={(item, index) => (
              <div className="flex flex-col gap-3 border p-2 border-gray-200 rounded-md  mb-2">
              {item.log && (
                <small className="text-color-secondary text-[13px] font-semibold xl:text-[12px] w-full">
                  {item.log}
                </small>
              )}
              {item.audioUrl && (
                <div className="mt-2 ">
                  <div className=" text-[12px] text-customGreen font-semibold  w-full mb-1">
                    Audio Note: <Music size={15} className="inline-block text-[6px] ml-1 mb-1 text-customGreen" />
                  </div>
                  <AudioPlayer 
                    audioUrl={item.audioUrl} 
                    className="max-w-md" 
                    audioId={`audio-${index}`}
                    onPlay={handleAudioPlay}
                    onRegister={registerAudioPlayer}
                    onUnregister={unregisterAudioPlayer}
                  />
                </div>
              )}
              {item.updatedBy && (
                <small className="text-color-secondary text-[13px] font-semibold xl:text-[13px] w-full">
                  updated by : {item.updatedBy}
                </small>
              )}
              
            </div>
            )}
            marker={(item) => (
              <span
                className="custom-marker"
                style={{ borderColor: "#399E79", borderWidth: "3px" }}
              ></span>
            )}
          />
        </div>
      ) : (
        <div className="text-center h-[225px] flex flex-col items-center justify-center">
          <svg viewBox="0 0 240 180" className="w-48 h-36 mx-auto mb-6">
            <defs>
              <linearGradient
                id="historyGrad"
                x1="0%"
                y1="0%"
                x2="100%"
                y2="100%"
              >
                <stop offset="0%" stopColor="#3B82F6" stopOpacity="0.1" />
                <stop offset="100%" stopColor="#1E40AF" stopOpacity="0.05" />
              </linearGradient>
              <linearGradient
                id="clockGrad"
                x1="0%"
                y1="0%"
                x2="100%"
                y2="100%"
              >
                <stop offset="0%" stopColor="#6366F1" stopOpacity="0.8" />
                <stop offset="100%" stopColor="#4F46E5" stopOpacity="0.6" />
              </linearGradient>
            </defs>

            {/* Main document */}
            <rect
              x="80"
              y="50"
              width="80"
              height="100"
              rx="8"
              fill="url(#historyGrad)"
              stroke="#E5E7EB"
              strokeWidth="2"
            />

            {/* Document lines */}
            <line
              x1="95"
              y1="70"
              x2="145"
              y2="70"
              stroke="#D1D5DB"
              strokeWidth="2"
              strokeLinecap="round"
            />
            <line
              x1="95"
              y1="80"
              x2="135"
              y2="80"
              stroke="#D1D5DB"
              strokeWidth="2"
              strokeLinecap="round"
            />
            <line
              x1="95"
              y1="90"
              x2="140"
              y2="90"
              stroke="#D1D5DB"
              strokeWidth="2"
              strokeLinecap="round"
            />

            {/* Large clock overlay */}
            <circle
              cx="120"
              cy="110"
              r="20"
              fill="url(#clockGrad)"
              stroke="#4F46E5"
              strokeWidth="2"
            />

            {/* Clock face details */}
            <circle
              cx="120"
              cy="110"
              r="15"
              fill="none"
              stroke="#FFFFFF"
              strokeWidth="1.5"
            />

            {/* Clock hands */}
            <line
              x1="120"
              y1="110"
              x2="120"
              y2="100"
              stroke="#FFFFFF"
              strokeWidth="2.5"
              strokeLinecap="round"
            />
            <line
              x1="120"
              y1="110"
              x2="127"
              y2="110"
              stroke="#FFFFFF"
              strokeWidth="2.5"
              strokeLinecap="round"
            />

            {/* Clock center dot */}
            <circle cx="120" cy="110" r="2" fill="#FFFFFF" />

            {/* Decorative floating elements */}
            <circle cx="50" cy="70" r="3" fill="#93C5FD" opacity="0.6" />
            <circle cx="190" cy="85" r="2.5" fill="#60A5FA" opacity="0.5" />
            <circle cx="200" cy="60" r="3.5" fill="#3B82F6" opacity="0.4" />
            <circle cx="40" cy="120" r="2" fill="#6366F1" opacity="0.5" />
            <circle cx="180" cy="130" r="2.5" fill="#4F46E5" opacity="0.4" />

            {/* Subtle background circles */}
            <circle cx="120" cy="40" r="25" fill="#F8FAFC" opacity="0.8" />
            <circle cx="60" cy="140" r="20" fill="#F1F5F9" opacity="0.6" />
            <circle cx="180" cy="160" r="18" fill="#E2E8F0" opacity="0.5" />
          </svg>

          <div className="text-slate-600 text-xl font-medium mb-2">
            No Notes History Found
          </div>
          <div className="text-slate-400 text-sm max-w-xs">
            There are no recorded activities or changes for this lead yet.
          </div>
        </div>
      )}
    </div>
  );
};

export default LeadNotesHistory;
